import getCurrentLanguageKey from 'Jsx/Utils/getCurrentLanguageKey';

import localeEs from './localeEs';
import localePt from './localePt';
import localeEn from './localeEn';

export const langEs = localeEs.es;
export const langPt = localePt.pt;
export const langEn = localeEn.en;

export const currentLanguageKey = getCurrentLanguageKey();

// eslint-disable-next-line no-nested-ternary
const I18N_STRINGS = currentLanguageKey === 'en' ? langEn : currentLanguageKey === 'es' ? langEs : langPt;

export type CheckoutTKeys = keyof typeof I18N_STRINGS;

export default I18N_STRINGS;
